import type { FC } from 'react';
import { COLOR_SCHEME } from '../../constants';
import { MultiSelectDesktop } from './components/MultiSelectDesktop';
import { MultiSelectMobile } from './components/MultiSelectMobile';
import { MultiSelectCommonProps, MultiSelectProps, Option } from './types';

const emptyStrArr: string[] = [];
const emptyOptionsArr: Option[] = [];

export const MultiSelect: FC<MultiSelectProps> = ({
  t,
  options = emptyOptionsArr,
  groupBy,
  groupsData,
  value = emptyStrArr,
  onChange,
  disabled = false,
  placeholder,
  searchPlaceholder = t('uikit.multiSelect.search.placeholder'),
  isDesktop,
  title,
  kind = 'count',
  size = 'xs',
  intent = 'default',
  hasSearch = false,
  isInlineSearch = true,
  style,
  className,
  classNames,
  customTrigger,
  showSelectAll = false,
  dataRole,
  haveToCloseOutsideClick = true,
  intentType = COLOR_SCHEME.PRIMARY,
  isExpandable = false,
  isOpenExternal,
  setIsOpenExternal
}) => {
  const commonProps: MultiSelectCommonProps = {
    t,
    options,
    groupBy,
    groupsData,
    value,
    onChange,
    disabled,
    placeholder,
    searchPlaceholder,
    title,
    kind,
    size,
    intent,
    hasSearch,
    isInlineSearch,
    style,
    className,
    classNames,
    customTrigger,
    showSelectAll,
    dataRole,
    intentType,
    isExpandable,
    isOpenExternal,
    setIsOpenExternal
  };

  return isDesktop || hasSearch || groupBy ? (
    <MultiSelectDesktop
      {...commonProps}
      haveToCloseOutsideClick={haveToCloseOutsideClick}
    />
  ) : (
    <MultiSelectMobile {...commonProps} />
  );
};
